













import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckoutLocationItem from './CheckoutLocationItem.vue';
import { ContractLocation } from '../../../store/location/types';
import { ProductServerLocation } from '../../../store/product/types';

@Component({ components: { CheckoutLocationItem } })
export default class CheckoutLocationList extends Vue {
  name = 'CheckoutLocationList';

  @Prop({ type: Array, required: true }) readonly locations!: Array<ProductServerLocation>;

  @Prop({ type: Object, required: false }) readonly selected!: ProductServerLocation;

  locationSelect(location: ProductServerLocation): void {
    this.$emit('location-select', location);
  }
}
